module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_02b.653e5637.jpg";